import Auth from './Auth';
import config from 'config';

/**
 * Authentication
 */
const auth = new Auth(config.auth);

export default auth;
